export function isChecksumValid(checksum: string) {
  return /^[A-Z]{2}-[A-Z0-9]{6}$/.test(checksum);
}
